import { defineComponent as _defineComponent } from 'vue'
import {PropType, ref, watch, computed, unref} from "vue";
import {useI18n} from "@/composables/useI18n";
import VueI18n from "vue-i18n";
import {Customer} from "@/components/customers/scripts/types";
import {hasValidDecimals, isBiggerOrEqualTo, isSmallerOrEqualTo} from "@/scripts/Common/validators/defaultValidator";
import {
  maximumMoneyDecimalCount,
  maximumVoucherAmount,
  minumumVoucherAmount
} from "@/scripts/Common/constraints/constraints";


export default /*#__PURE__*/_defineComponent({
  __name: 'VoucherEdit',
  props: {
  label: {
    required: true,
    type: String as PropType<string | VueI18n.TranslateResult>,
  },
  hasNoEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  model: {
    required: true,
    type: Object as PropType<Customer>,
  },
  expanded: {
    required: false,
    type: Array as PropType<number[]>,
    default() {
      return [1]
    }
  },
},
  emits: [
  'onValidChange',
  'update:useVoucher',
  'update:voucherAmount'
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
} = useI18n();





const valid = ref(true);
const voucherForm = ref();

const internalExpand = ref(props.expanded);

const useVoucher = computed({
  get() {
    return props.model.useVoucher
  },
  set(value: boolean) {
    emits('update:useVoucher', value);
  }
})

const voucherAmount = computed({
  get() {
    return props.model.voucherAmount;
  },
  set(value: number) {
    emits('update:voucherAmount', value)
  }
})

const validate = () =>  voucherForm.value.validate();

watch(valid, () => {
  emits('onValidChange', unref(valid))
})

watch(() => props.expanded, () => {
  internalExpand.value = props.expanded
})

return { __sfc: true,t, props, emits, valid, voucherForm, internalExpand, useVoucher, voucherAmount, validate, hasValidDecimals, isBiggerOrEqualTo, isSmallerOrEqualTo, maximumMoneyDecimalCount, maximumVoucherAmount, minumumVoucherAmount }
}

})